<script>
import t from '@/components/page/HomeView/data/text.json'

export default {
  props: [
    'page'
  ],
  data() {
    return {
      isOpen: false,
      t
    }
  },
}
</script>

<template>
  <div class="float">
    <div class="float__open" @click="isOpen = !isOpen">
      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="17.5703" y="0.142822" width="1.64569" height="17.1429" transform="rotate(90 17.5703 0.142822)"
              fill="white"/>
        <rect x="17.5703" y="6.17719" width="1.64569" height="17.1429" transform="rotate(90 17.5703 6.17719)"
              fill="white"/>
        <rect x="17.5703" y="12.2114" width="1.64569" height="17.1429" transform="rotate(90 17.5703 12.2114)"
              fill="white"/>
      </svg>
    </div>

    <div :class="{active: isOpen}" class="float__menu-list">
      <div class="float__menu-list-scroll">
        <router-link @click="isOpen = !isOpen" :to="item.link" class="float__item" v-for="(item, id) in t.itemPages"
                     :key="id">
          <div class="float__img">
            <div class="float__img-icon">

              <svg class="float__img-icon--icon1" v-show="item.iconType === 'интерактив'"
                   width="14" height="16"
                   viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.11111 3.2C3.11111 2.35131 3.43889 1.53737 4.02233 0.937258C4.60578 0.337142 5.3971 0 6.22222 0C7.04734 0 7.83866 0.337142 8.42211 0.937258C9.00556 1.53737 9.33333 2.35131 9.33333 3.2H13.2222C13.4285 3.2 13.6263 3.28429 13.7722 3.43431C13.9181 3.58434 14 3.78783 14 4V7.336C14.0001 7.46403 13.9704 7.59023 13.9133 7.70398C13.8561 7.81774 13.7733 7.91573 13.6717 7.98973C13.5701 8.06372 13.4528 8.11156 13.3295 8.12921C13.2062 8.14687 13.0806 8.13384 12.9632 8.0912C12.7287 8.00626 12.4777 7.9804 12.2314 8.01579C11.9851 8.05118 11.7507 8.1468 11.5477 8.29462C11.3448 8.44244 11.1792 8.63815 11.065 8.86535C10.9507 9.09255 10.8911 9.34461 10.8911 9.6004C10.8911 9.85619 10.9507 10.1083 11.065 10.3355C11.1792 10.5626 11.3448 10.7584 11.5477 10.9062C11.7507 11.054 11.9851 11.1496 12.2314 11.185C12.4777 11.2204 12.7287 11.1945 12.9632 11.1096C13.0805 11.067 13.2059 11.054 13.3291 11.0715C13.4523 11.0891 13.5695 11.1368 13.6711 11.2106C13.7726 11.2844 13.8555 11.3822 13.9127 11.4957C13.97 11.6093 13.9999 11.7353 14 11.8632V15.2C14 15.4122 13.9181 15.6157 13.7722 15.7657C13.6263 15.9157 13.4285 16 13.2222 16H0.777778C0.571498 16 0.373667 15.9157 0.227806 15.7657C0.0819442 15.6157 0 15.4122 0 15.2V4C0 3.78783 0.0819442 3.58434 0.227806 3.43431C0.373667 3.28429 0.571498 3.2 0.777778 3.2H3.11111ZM6.22222 1.6C5.97331 1.59994 5.72801 1.66131 5.50694 1.77898C5.28587 1.89664 5.09548 2.06715 4.95176 2.27619C4.80804 2.48523 4.71519 2.72669 4.68101 2.98029C4.64683 3.2339 4.67232 3.49223 4.75533 3.7336C4.79678 3.85433 4.80946 3.98352 4.79229 4.11033C4.77513 4.23714 4.72862 4.35786 4.65668 4.46235C4.58474 4.56683 4.48947 4.65203 4.37887 4.71079C4.26828 4.76954 4.14559 4.80014 4.02111 4.8H1.55556V14.4H12.4444V12.8C11.6193 12.8 10.828 12.4629 10.2446 11.8627C9.66111 11.2626 9.33333 10.4487 9.33333 9.6C9.33333 8.75131 9.66111 7.93737 10.2446 7.33726C10.828 6.73714 11.6193 6.4 12.4444 6.4V4.8H8.42333C8.29886 4.80014 8.17617 4.76954 8.06557 4.71079C7.95497 4.65203 7.85971 4.56683 7.78777 4.46235C7.71583 4.35786 7.66932 4.23714 7.65215 4.11033C7.63499 3.98352 7.64766 3.85433 7.68911 3.7336C7.77212 3.49223 7.79761 3.2339 7.76343 2.98029C7.72925 2.72669 7.6364 2.48523 7.49268 2.27619C7.34897 2.06715 7.15857 1.89664 6.9375 1.77898C6.71643 1.66131 6.47114 1.59994 6.22222 1.6Z"
                  fill="white"/>
              </svg>

              <svg class="float__img-icon--icon2" v-show="item.iconType === 'Статья'" width="18"
                   height="8"
                   viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.09131 1.59963C3.44026 1.59963 2.81588 1.85242 2.35552 2.3024C1.89515 2.75239 1.63653 3.36269 1.63653 3.99906C1.63653 4.63543 1.89515 5.24574 2.35552 5.69572C2.81588 6.1457 3.44026 6.3985 4.09131 6.3985C4.74236 6.3985 5.36675 6.1457 5.82711 5.69572C6.28747 5.24574 6.5461 4.63543 6.5461 3.99906C6.5461 3.36269 6.28747 2.75239 5.82711 2.3024C5.36675 1.85242 4.74236 1.59963 4.09131 1.59963ZM0 3.99906C8.1383e-05 3.2398 0.221293 2.49625 0.63777 1.85534C1.05425 1.21444 1.64878 0.702663 2.35186 0.379856C3.05493 0.057049 3.8375 -0.06345 4.60806 0.0324465C5.37861 0.128343 6.10532 0.436673 6.70321 0.921386C7.31487 0.330179 8.14067 -0.000971432 9.00089 2.14064e-06C9.89689 2.14064e-06 10.7078 0.35192 11.2986 0.921386C12.0787 0.289635 13.0709 -0.0367189 14.0831 0.00550317C15.0953 0.0477252 16.0555 0.455521 16.7777 1.14994C17.5 1.84436 17.933 2.77602 17.9928 3.76455C18.0527 4.75308 17.7353 5.72817 17.1019 6.50105C16.4685 7.27393 15.5643 7.78963 14.5643 7.94831C13.5643 8.10699 12.5396 7.89737 11.6886 7.36002C10.8376 6.82268 10.2209 5.99583 9.95776 5.03955C9.69464 4.08327 9.80387 3.06558 10.2643 2.18349C10.111 2.00087 9.91818 1.85377 9.6997 1.75281C9.48123 1.65184 9.24255 1.59952 9.00089 1.59963C8.49357 1.59963 8.0378 1.82597 7.73749 2.18349C8.01799 2.72216 8.16992 3.31597 8.18186 3.92029C8.1938 4.5246 8.06544 5.12371 7.80643 5.67256C7.54742 6.22141 7.16449 6.70574 6.68643 7.08913C6.20838 7.47252 5.64763 7.745 5.04634 7.88609C4.44505 8.02718 3.81886 8.03321 3.21484 7.90372C2.61082 7.77424 2.04469 7.51261 1.559 7.13849C1.07331 6.76438 0.680699 6.28753 0.410675 5.74377C0.140651 5.20001 0.000240898 4.60349 0 3.99906ZM13.9105 1.59963C13.588 1.59921 13.2686 1.66098 12.9706 1.78142C12.6725 1.90185 12.4017 2.07857 12.1737 2.30147C11.9457 2.52436 11.7649 2.78904 11.6417 3.08034C11.5184 3.37164 11.4552 3.68385 11.4557 3.99906C11.4557 4.47363 11.5996 4.93753 11.8694 5.33212C12.1391 5.7267 12.5225 6.03425 12.9711 6.21585C13.4196 6.39746 13.9132 6.44498 14.3894 6.3524C14.8656 6.25981 15.303 6.03129 15.6463 5.69572C15.9896 5.36015 16.2234 4.93262 16.3181 4.46717C16.4128 4.00172 16.3642 3.51928 16.1784 3.08084C15.9926 2.6424 15.678 2.26766 15.2743 2.004C14.8706 1.74035 14.396 1.59963 13.9105 1.59963Z"
                  fill="white"/>
              </svg>

              <svg class="float__img-icon--icon3" v-show="item.iconType === 'Видео'" width="13"
                   height="16"
                   viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M0 2.64625C0 0.698991 2.17022 -0.462474 3.79044 0.617671L11.4251 5.70748C12.8727 6.67251 12.8727 8.7996 11.4251 9.76464L3.79043 14.8544C2.17022 15.9346 0 14.7731 0 12.8259V2.64625ZM2.88884 1.97006C2.34877 1.61001 1.62537 1.99716 1.62537 2.64625V12.8259C1.62537 13.475 2.34877 13.8621 2.88884 13.5021L10.5236 8.41225C11.0061 8.09057 11.0061 7.38154 10.5236 7.05987L2.88884 1.97006Z"
                      fill="white"/>
              </svg>

              <svg class="float__img-icon--icon4" v-show="item.iconType === 'Квиз'" width="24"
                   height="24"
                   viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_431_2555" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24"
                      height="24">
                  <rect width="24" height="24" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_431_2555)">
                  <path
                    d="M11.989 17.6154C12.2745 17.6154 12.5157 17.5169 12.7125 17.3199C12.9093 17.1227 13.0078 16.8813 13.0078 16.5956C13.0078 16.3101 12.9092 16.069 12.712 15.8721C12.5148 15.6755 12.2735 15.5771 11.988 15.5771C11.7025 15.5771 11.4613 15.6757 11.2645 15.8729C11.0677 16.07 10.9693 16.3114 10.9693 16.5969C10.9693 16.8824 11.0678 17.1235 11.265 17.3204C11.4622 17.517 11.7035 17.6154 11.989 17.6154ZM11.2808 14.0346H12.6885C12.7013 13.5425 12.7734 13.1492 12.9048 12.8549C13.0363 12.5607 13.3552 12.1707 13.8615 11.6849C14.3013 11.245 14.6382 10.8389 14.872 10.4664C15.106 10.094 15.223 9.65429 15.223 9.14712C15.223 8.28629 14.9138 7.61387 14.2953 7.12987C13.6766 6.64604 12.9448 6.40412 12.1 6.40412C11.2653 6.40412 10.5747 6.62687 10.028 7.07237C9.48117 7.51787 9.09108 8.04254 8.85775 8.64637L10.1423 9.16162C10.2641 8.82962 10.4724 8.50621 10.7673 8.19137C11.0621 7.87671 11.4999 7.71937 12.0808 7.71937C12.6718 7.71937 13.1086 7.88121 13.3913 8.20487C13.6741 8.52871 13.8155 8.88479 13.8155 9.27312C13.8155 9.61296 13.7187 9.92387 13.525 10.2059C13.3315 10.4879 13.0848 10.7603 12.7848 11.0231C12.1283 11.6155 11.7135 12.088 11.5405 12.4406C11.3673 12.7931 11.2808 13.3245 11.2808 14.0346ZM12.0018 21.5001C10.6878 21.5001 9.45267 21.2508 8.2965 20.7521C7.14033 20.2535 6.13467 19.5767 5.2795 18.7219C4.42433 17.867 3.74725 16.8618 3.24825 15.7061C2.74942 14.5505 2.5 13.3157 2.5 12.0019C2.5 10.6879 2.74933 9.45279 3.248 8.29662C3.74667 7.14046 4.42342 6.13479 5.27825 5.27962C6.13308 4.42446 7.13833 3.74737 8.294 3.24837C9.44967 2.74954 10.6844 2.50012 11.9983 2.50012C13.3123 2.50012 14.5473 2.74946 15.7035 3.24812C16.8597 3.74679 17.8653 4.42354 18.7205 5.27837C19.5757 6.13321 20.2528 7.13846 20.7518 8.29412C21.2506 9.44979 21.5 10.6845 21.5 11.9984C21.5 13.3124 21.2507 14.5475 20.752 15.7036C20.2533 16.8598 19.5766 17.8655 18.7218 18.7206C17.8669 19.5758 16.8617 20.2529 15.706 20.7519C14.5503 21.2507 13.3156 21.5001 12.0018 21.5001ZM12 20.0001C14.2333 20.0001 16.125 19.2251 17.675 17.6751C19.225 16.1251 20 14.2335 20 12.0001C20 9.76679 19.225 7.87512 17.675 6.32512C16.125 4.77512 14.2333 4.00012 12 4.00012C9.76667 4.00012 7.875 4.77512 6.325 6.32512C4.775 7.87512 4 9.76679 4 12.0001C4 14.2335 4.775 16.1251 6.325 17.6751C7.875 19.2251 9.76667 20.0001 12 20.0001Z"
                    fill="white"/>
                </g>
              </svg>

            </div>

            <picture>
              <source :srcset="require(`@/assets/img/page/HomeView/mob/${item.img}.webp`)"
                      type="image/webp">
              <img class="float__img-main" :src="require(`@/assets/img/page/HomeView/mob/${item.img}.jpg`)"
                   :alt="`${item.name}`">
            </picture>
          </div>
          <div class="float__col">
            <p class="float__type" v-html="item.iconType"></p>
            <h2 class="float__title" v-html="item.name"></h2>
          </div>

        </router-link>
      </div>

      <div @click="isOpen = !isOpen" class="float__close">
        <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.30469 1.50256L16.821 17.0189" stroke="white" stroke-width="1.71429"/>
          <path d="M1.30469 16.8629L16.821 1.34659" stroke="white" stroke-width="1.71429"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.float {

  &__open {

    position: fixed;
    right: 60px;
    bottom: 70px;

    width: 48px;
    height: 48px;

    display: flex;
    justify-content: center;
    align-items: center;

    background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(94.58deg, rgba(185, 0, 255, 0.35) 0%, rgba(77, 214, 255, 0.35) 100%);
    box-shadow: 0px 17.3333px 13.3333px rgba(10, 5, 32, 0.17), inset 0px 0px 20px rgba(228, 130, 255, 0.25);
    backdrop-filter: blur(13.3333px);
    border: 1px solid rgba(255, 255, 255, 0);

    overflow: hidden;

    z-index: 200;

    @media screen and (max-width: 1024px) {
      right: 20px;
      bottom: 20px;

    }

    @media screen and (min-width: 1024px) {
      &:hover {
        user-select: none;
        cursor: pointer;


        border: 1px solid #E482FF;

        background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
        box-shadow: inset 0px 0px 24px rgba(228, 130, 255, 0.25);
        filter: drop-shadow(0px 20.8px 16px rgba(10, 5, 32, 0.17));
        backdrop-filter: blur(16px);

        svg {
          rect {
            fill: #E482FF;
          }
        }

        &:after {
          opacity: 0;
        }
      }
    }

    &:active {
      user-select: none;
      border: 1px solid rgba(228, 130, 255, 0);
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
      box-shadow: inset 0px 0px 24px rgba(228, 130, 255, 0.25);
      filter: drop-shadow(0px 20.8px 16px rgba(10, 5, 32, 0.17));
      backdrop-filter: blur(16px);

      svg {
        rect {
          fill: #E482FF;
        }
      }

      &:before {
        opacity: 0;
      }

      &:after {
        opacity: 0;
      }
    }

    &:before {
      content: '';

      /* Rectangle 11 */


      position: absolute;
      height: 1px;
      left: 0;
      right: 0;
      bottom: 0;

      background: linear-gradient(90deg, #D84CFF 0%, #00CFFF 100%);
      border-top: 0.375px solid rgba(255, 255, 255, 0.5);


    }

    &:after {
      content: '';

      position: absolute;
      height: 62px;
      left: 0;
      right: 0;
      top: 70%;

      background: linear-gradient(90deg, #E482FF 0%, #3ED2F4 100%);
      filter: blur(5px);
      border-radius: 250px;

    }

    svg {
      width: 18px;
      height: auto;
      display: block;
      position: relative;
      z-index: 2;
    }


  }

  &__close {

    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    width: 48px;
    height: 48px;
    right: 20px;
    bottom: 20px;

    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%);
    box-shadow: 0px 0px 24px 0px rgba(228, 130, 255, 0.25) inset, 0px 20.8px 16px 0px rgba(10, 5, 32, 0.17);
    backdrop-filter: blur(16px);

    @media screen and (min-width: 1024px) {
      &:hover {
        user-select: none;
        cursor: pointer;

        background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
        border: 1.2px solid rgba(255, 255, 255, 0.3);
        box-shadow: inset 0px 0px 24px rgba(228, 130, 255, 0.25);
        filter: drop-shadow(0px 20.8px 16px rgba(10, 5, 32, 0.17));
        backdrop-filter: blur(16px);

        svg {
          path {
            stroke: var(--Accent-Purple, #E482FF);
          }
        }

        &:before {
          opacity: 1;
        }
      }
    }

    &:active {
      user-select: none;
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
      filter: drop-shadow(0px 20.8px 16px rgba(10, 5, 32, 0.17));
      backdrop-filter: blur(16px);

      svg {
        path {
          stroke: var(--Accent-Purple, #E482FF);
        }
      }

      &:before {
        opacity: 0;
      }
    }

    &:before {
      content: '';

      opacity: 0;

      box-sizing: border-box;

      position: absolute;
      width: 100%;
      height: 2px;
      left: 0;
      right: 0;
      bottom: 0;

      background: linear-gradient(90deg, #D84CFF 0%, #00CFFF 100%);
      border-top: 0.45px solid rgba(255, 255, 255, 0.5);

    }

    svg {
      width: 17px;
      height: auto;
      display: block;
    }
  }

  &__item {
    display: flex;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    @media screen and (min-width: 1024px) {
      &:hover {
        user-select: none;

        .float__img-icon {
          border: 1px solid rgba(255, 255, 255, 0.25);

          background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
          box-shadow: inset 0px 0px 24px rgba(228, 130, 255, 0.25);
          filter: drop-shadow(0px 20.8px 16px rgba(10, 5, 32, 0.17));
          backdrop-filter: blur(16px);

          &:after {
            opacity: 0;
          }

          &:before {
            opacity: 0;
          }
        }
      }
    }

    &:active {
      user-select: none;

      .float__img-icon {
        border: 1px solid rgba(255, 255, 255, 0.25);

        background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
        box-shadow: inset 0px 0px 24px rgba(228, 130, 255, 0.25);
        filter: drop-shadow(0px 20.8px 16px rgba(10, 5, 32, 0.17));
        backdrop-filter: blur(16px);

        &:after {
          opacity: 0;
        }

        &:before {
          opacity: 0;
        }
      }
    }
  }

  &__menu-list {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;

    max-width: 394px;
    width: 100%;

    background: #320C46;

    transition: transform 1s ease-in-out;
    transform: translateX(100%);
    z-index: 9999999;


    @media screen and (max-width: 600px) {
      max-width: 600px;
      background: linear-gradient(111deg, #40143C 0%, #270650 96.23%);
      padding-left: 20px;
      padding-right: 20px;
    }

    &-scroll {
      padding: 40px 17px;

      min-height: calc(100vh);
      min-height: calc((var(--vh, 1vh) * 100));

      max-height: calc(100vh);
      max-height: calc((var(--vh, 1vh) * 100));

      overflow-y: auto;

      display: flex;
      flex-direction: column;

      @media screen and (max-width: 600px) {
        padding: 20px 0;
        max-height: calc(100vh);
        min-height: calc(100vh);

      }

      @media screen and (max-width: 1024px) and (max-height: 600px) {
        max-height: calc(100vh);
        min-height: calc(100vh);
      }
    }

    &.active {
      transform: translateX(0);
    }
  }

  &__img {
    max-width: 100px;
    min-width: 100px;
    width: 100%;
    position: relative;

    &-main {
      width: 100%;
      height: auto;
      display: block;
    }

    &-icon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      width: 30px;
      height: 30px;

      display: flex;
      justify-content: center;
      align-items: center;

      border: 1px solid rgba(255, 255, 255, 0);
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(94.58deg, rgba(185, 0, 255, 0.35) 0%, rgba(77, 214, 255, 0.35) 100%);
      box-shadow: 0px 17.3333px 13.3333px rgba(10, 5, 32, 0.17), inset 0px 0px 20px rgba(228, 130, 255, 0.25);
      backdrop-filter: blur(13.3333px);

      overflow: hidden;

      &:before {
        content: '';

        /* Rectangle 11 */


        position: absolute;
        height: 1px;
        left: 0;
        right: 0;
        bottom: 0;

        background: linear-gradient(90deg, #D84CFF 0%, #00CFFF 100%);
        border-top: 0.375px solid rgba(255, 255, 255, 0.5);


      }

      &:after {
        content: '';

        position: absolute;
        height: 62px;
        left: 0;
        right: 0;
        top: 70%;

        background: linear-gradient(90deg, #E482FF 0%, #3ED2F4 100%);
        filter: blur(5px);
        border-radius: 250px;

      }

      svg {
        position: relative;
        z-index: 2;
      }

      &--icon1 {
        width: 10px;
        height: auto;
        display: block;
      }

      &--icon2 {
        width: 13px;
        height: auto;
        display: block;
      }

      &--icon3 {
        width: 10px;
        height: auto;
        display: block;
      }

      &--icon4 {
        width: 18px;
        height: auto;
        display: block;
      }
    }
  }

  &__col {
    margin-left: 20px;

    @media screen and (max-width: 1024px) {
    }

    @media screen and (max-width: 600px) {
    }
  }

  &__type {
    color: var(--Accent-Purple, #E482FF);
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    margin-bottom: 4px;
    @media screen and (max-width: 1024px) {
    }
  }

  &__title {
    color: var(--Text-White, #FFF);
    font-family: 'MetaPro', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;

    @media screen and (max-width: 1024px) {
    }
  }
}
</style>